module.exports = "<p>{{ message }}</p>\r\n"